// clubLogos.js
const clubLogos = {
    "BSI": "https://bsi.no/wp-content/uploads/2024/02/Design-uten-navn.png",
    "Haugesund": "https://haugesundbk.net/bilder/logo/ny_logo_transparent_haugesund.png",
    "Bergen": "https://wordpress.bergenbk.no/wp-content/uploads/2013/05/cropped-copy-cropped-Logo-BBK.jpg",
    "Sotra": "https://radiosotra.no/wp-content/uploads/sotrabadminton.webp",
    "Kristiansand": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbBjtMvxDdvUFAiRpe0Yw6rphvyhgwzTLoqEelXNz52rlYLovq7ijKWu0lPVgiFNwEchY&usqp=CAU",
    "Haugerud": "https://media.licdn.com/dms/image/C4D0BAQGc4DkyhwuK6A/company-logo_200_200/0/1630507581423?e=2147483647&v=beta&t=kLK8UByr55zkh-OQys1d4ZejCjqoimAGnCWtmyPmGus",
    "Klemetsrud": "https://www.klemetsrudil.no/wp-content/uploads/2018/08/Klemetsrud-IL.png",
    "Bygdø": "https://www.bygdoehus.no/images/ByBK.jpg",    // Add more clubs as needed
    "Askøy": "https://askoybadmintonklubb.no/home/wp-content/uploads/2018/11/abklogo.png",
    "Karmøy": "https://kabk.no/images/logo.png",
    "Djerv": "https://skdjerv.no/wp-content/uploads/2023/01/djerv-logo-2.png",
    "Tromsø": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQFiRJwhyOnwQnpr9Ye6w8oE8x0ezBFVpQWMw&usqp=CAU",
    "Grimstad": "https://i.gyazo.com/992ca2c3fea6087710bc8debef29d45f.png",
    "Moss": "https://static.wixstatic.com/media/a4aef8_570a4e4a6e074f5091cd546e327bfb5c~mv2.png",
  };
  
  export default clubLogos;
  